import { validate } from '@frm-errors/functions/validate';
import type { ApiErrorInterface } from '@zaoblako/shared/common/dtos/api-error.dto';

import { plainToClass } from 'class-transformer';

export function validateForm<T = any>(data: any, dto: new () => T): { valid: boolean; errors?: ApiErrorInterface<T> } {
  const result: T = plainToClass(dto, data);

  const errors = validate(result, dto);

  if (errors) {
    return { valid: false, errors };
  }

  return { valid: true };
}
